<template>
  <div class="right_body_s" v-loading="isLoading">
    <Panel>
      <template v-slot:panel-top>
        <Toolbar :items=toolBarItems
                 @onAddMtrlType="onAddMtrlType"
                 @onEditMtrlType="onEditMtrlType"
                 @onDelMtrlType="onDelMtrlType"></Toolbar>
      </template>
      <template v-slot:panel-main>
         <MtrlTypeFGridPanel ref="formGridPanel"
                             @onConditionQuery="onConditionQuery"></MtrlTypeFGridPanel>
      </template>
    </Panel>
    <MtrlTypeNeWindow ref="mtrlTypeWin" :visible="showMtrlTypWin" :formData=currentMtrlTypeRow :title="mtrlTypFuncTitle"
                      @onClose="onCloseMtrlTypWin"
                      @onSubmit="onAddOrModifyMtrlType"></MtrlTypeNeWindow>    
  </div>
</template>
 
<script>
import MtrlTypeNeWindow from "./ui/MaterialTypeNeWindow.vue";
import Toolbar from 'components/bar/Toolbar.vue'
import MtrlTypeFGridPanel from "./ui/MaterialTypeQgPanel.vue"
import Panel from "components/container/BasePanel.vue";
import MaterialTypeManage from "./service/MaterialTypeManage.service.js";
import {URL_PLATFORM_RESOURCE} from "./service/MaterialTypeManage.service.js";

const ToolBarItems=[{
                class:"toolbar-item add_btn",
                name:"新增", 
                click:"onAddMtrlType",
                iconfont:"&#xe7e4;" 
          },{ 
                class:"toolbar-item edit_btn",
                name:"编辑",
                click:"onEditMtrlType",
                iconfont:"&#xe678;" 
          },{
                class:"toolbar-item del_btn",
                name:"删除",
                click:"onDelMtrlType",
                iconfont:"&#xe618;" 
          }]

//工作状态          
const WorkStatusType={
  scan:'scan',
  new:'new',
  edit:'edit'
}

export default {
  components: { Panel,Toolbar, MtrlTypeNeWindow,  MtrlTypeFGridPanel },
  data() {
    return {
      showMtrlTypWin:false,
      toolBarItems:ToolBarItems||[],
      mtrlTypFuncTitle:'物料类型-新增',
      workStatus:WorkStatusType.scan,
      currentMtrlTypeRow:{},
      Url:URL_PLATFORM_RESOURCE.list,
      // columns: TableColumns,
      isShowMaterialDialog: false,
      formLabelWidth: "100px",
      isLoading: false,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      fromData: {
        currentNumber:0//当前数默认为0
      },
      title: ""
    };
  },
  created() {},
  updated: function() {

  },
  methods: {
    ...MaterialTypeManage,
    /**
     * 触发添加物料类型
     */
    onAddMtrlType() {
      this.title = "物料类别-新增";
      this.showMtrlTypWin = true;
      this.workStatus=WorkStatusType.new;
    },
    onCloseMtrlTypWin(){
       let vm=this;
       vm.showMtrlTypWin=false;
    },
    /**
     * 添加或是修改物料类型
     */
    onAddOrModifyMtrlType(formData){
        let vm=this;
        if( vm.workStatus==WorkStatusType.new){
          vm.submitNewMtrlType(formData,function(response){
              vm.processResponseResult(null,response);
          });
        }else if(vm.workStatus==WorkStatusType.edit){
          vm.submitModifyMtrlType(formData,function(response){
              vm.processResponseResult(formData.materialTypeId,response);
          });
        }
        //重新设置为浏览状态
        vm.workStatus=WorkStatusType.scan;
    },
    /**
     * 条件查询
     */
    onConditionQuery(){
        let vm=this,formGridPanel=this.$refs.formGridPanel;
        vm.searchMaterialTypes({page:1,pageSize:10000,searchCriteria:{}},function(response){
          //加载页面数据
          if(response.data){
              formGridPanel.loadPageData(response.data);
          }
        });
    },
    /**
     * 编辑物料类型
     */
    onEditMtrlType(){
      let vm=this,formGridPanel=this.$refs.formGridPanel,selectedRow;
      selectedRow=formGridPanel.getSelectedRow();
      if(!selectedRow){
        return;
      }      
      vm.showMtrlTypWin = true;
      vm.mtrlTypFuncTitle='物料类型-编辑';
      //编辑数据行
      vm.currentMtrlTypeRow=selectedRow;
      //编辑中
      vm.workStatus=WorkStatusType.edit;
    },
    /**
     * 删除物料类型
     */
    onDelMtrlType(){
      let vm=this,formGridPanel=this.$refs.formGridPanel,selectedRow;
      selectedRow=formGridPanel.getSelectedRow();
      
      if(!selectedRow){
        return;
      } 
      let message="确定删除记录:"+selectedRow.materialTypeDesc+", 是否继续?";        
      vm.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
           vm.submitDelMtrlType(selectedRow,function(response){
               vm.processDelResponse(response);
           });
      }).catch(() => {

      });
    },

    /**
     * 处理相应结果
     */
    processResponseResult(materialTypeId,response){
      let vm=this,message;
      if(response.type=="F"){
        vm.$message.error(response.errorMsg);
        return;
      }
      if(materialTypeId){
        message="物料类别 " + response.data.materialTypeDesc + "修改成功";
      }else{
        message="物料类别 " + response.data.materialTypeDesc + " 已添加成功";
      }
      vm.showMtrlTypWin = false;

      vm.$alert(message, "操作提示", {
          confirmButtonText: "确定",
          type: "success",
          callback: action => {            
            vm.onConditionQuery();
          }
      });
    },
    /**
     * 处理删除响应
     */
    processDelResponse(response){
      let vm=this;
      if(response.type=="F"){
        vm.$message.error(response.errorMsg||response.msg);
        return;
      }
      //重新删除
      vm.onConditionQuery();
    },

    doing(){
       let vm=this;
       vm.isLoading = true;
       vm.loadingBg = "rgba(255,255,255,0.5)";
       vm.loadingTxt = "数据处理中...";
    },
    closing(){
       let vm=this;
       vm.isLoading = false;
    }
  }
};
</script>
